<script>
export default {
  name: "SupervisionView",
  data() {
    return {
      id: "",
      product: {},
      logo: require("../assets/xiehui.png"),
    }
  },
  created() {
    this.id = this.getParmeter("productId")
    this.productDetail(this.id);
  },
  methods: {
    productDetail(id) {
      const _this = this
      const data = {
        id: id
      }
      this.$axios.post('supply/detail', data).then(function (res) {
        _this.product = res.data.data
      }).catch(function (err) {
        _this.$message.error(err)
      })
    },
    getParmeter(variable) {
      let query = window.location.href.split("?")[1];
      let vars = query.split("&");
      for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        if (pair[0] === variable) {
          return pair[1];
        }
      }
      return "";
    },
    open(url, number) {
      console.log("传入值：" + url)
      this.$router.push({
        path: '/show',
        query: {
          url: url,
          number: number
        }
      });
    }
  }
}
</script>

<template>
  <div class="home">
    <div class="main">
      <img :src="logo" style="width: 80px;height: 80px;border-radius: 40px;margin-right: 20px;"/>
      <div class="title">智慧监管一品一码</div>
    </div>

    <van-image v-bind:src="product.image" class="product-image"/>
    <div class="report-title">产品信息</div>
    <van-cell-group>
      <van-cell title="产品名称:" v-bind:value="product.name" title-class="custom-title" value-class="custom-value"/>
      <van-cell title="产品数量:" v-bind:value="product.amount" title-class="custom-title" value-class="custom-value"/>
      <van-cell title="产品产地:" v-bind:value="product.address" title-class="custom-title" value-class="custom-value"/>
      <van-cell title="产品质量:" v-bind:value="product.level" title-class="custom-title" value-class="custom-value"/>
      <van-cell title="进货时间:" v-bind:value="product.buyDate" title-class="custom-title" value-class="custom-value"/>
      <van-cell title="供货商名称:" v-bind:value="product.sourceName" title-class="custom-title" value-class="custom-value"/>
      <van-cell title="供货商联系人:" v-bind:value="product.sourceContact" title-class="custom-title" value-class="custom-value"/>
      <van-cell title="供货商电话:" v-bind:value="product.sourcePhone" title-class="custom-title" value-class="custom-value"/>
    </van-cell-group>

<!--    <div style="margin-top: 5px">-->
<!--      <div class="report-title">企业主体信息</div>-->
<!--    </div>-->
<!--    <van-image v-bind:src="product.licenseImage" class="product-image"/>-->
<!--    <van-cell-group>-->
<!--      <van-cell title="营业执照名称:" v-bind:value="product.licenseName" title-class="custom-title" value-class="custom-value"/>-->
<!--      <van-cell title="社会信用代码:" v-bind:value="product.creditCode" title-class="custom-title" value-class="custom-value"/>-->
<!--      <van-cell title="法定代表人:" v-bind:value="product.legal" title-class="custom-title" value-class="custom-value"/>-->
<!--      <van-cell title="注册资本:" v-bind:value="product.registerMoney" title-class="custom-title" value-class="custom-value"/>-->
<!--      <van-cell title="成立日期:" v-bind:value="product.registerDate" title-class="custom-title" value-class="custom-value"/>-->
<!--      <van-cell title="住所:" v-bind:value="product.address" title-class="custom-title" value-class="custom-value"/>-->
<!--    </van-cell-group>-->


<!--    <div style="margin-top: 5px">-->
<!--      <div class="report-title">产品朔源</div>-->
<!--    </div>-->
<!--    <van-image v-bind:src="product.sourceImage" class="product-image"/>-->
<!--    <van-cell-group>-->
<!--      <van-cell title="产品种类:" v-bind:value="product.category" title-class="custom-title" value-class="custom-value"/>-->
<!--      <van-cell title="产品来源:" v-bind:value="product.source" title-class="custom-title" value-class="custom-value"/>-->
<!--      <van-cell title="企业名称:" v-bind:value="product.sourceName" title-class="custom-title" value-class="custom-value"/>-->
<!--      <van-cell title="联系人:" v-bind:value="product.sourceContact" title-class="custom-title" value-class="custom-value"/>-->
<!--      <van-cell title="联系电话:" v-bind:value="product.sourcePhone" title-class="custom-title" value-class="custom-value"/>-->
<!--      <van-cell title="进货时间:" v-bind:value="product.buyDate" title-class="custom-title" value-class="custom-value"/>-->
<!--      <van-cell title="产品质量:" v-bind:value="product.level" title-class="custom-title" value-class="custom-value"/>-->
<!--      <van-cell title="产品数量:" v-bind:value="product.amount" title-class="custom-title" value-class="custom-value"/>-->
<!--    </van-cell-group>-->



    <div>
      <div class="report-title">进货票据</div>
      <van-image v-bind:src="product.bill"/>
    </div>
    <div style="margin-top: 5px">
      <div class="report-title">检测报告</div>
      <van-image v-bind:src="product.report"/>
    </div>

    <div style="margin-top: 5px">
      <div class="report-title">产品合格证</div>
      <van-image v-bind:src="product.qualified"/>
    </div>

  </div>
</template>

<style scoped>

.home {
  width: 100vw;
  height: 100vh;
  overflow-y: scroll;
}

.main {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 20px;
  background-color: #1A7AF8;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

.product-image {
  width: 100%;
  height: 300px;
  object-fit: contain; /* 保持图片比例，完整显示 */
  background-color: #f5f5f5; /* 设置背景色避免空白区域 */
}


.van-cell {
  align-items: flex-start; /* 使单元格内容顶部对齐 */
}

.van-cell__value {
  max-width: calc(100% - 120px); /* 减去标题宽度 */
  word-wrap: break-word;
  white-space: normal;
}

.custom-title {
  flex: none;
  width: 120px;
}

.custom-value {
  flex: 1;
  text-align: left;
  min-width: 200px; /* 设置最小宽度 */
}


/* 优化后的样式 */
.title {
  font-size: 1.5rem; /* 使用相对单位更好适配 */
  color: white;
  margin-left: 20px;
  font-weight: bold; /* 增加字重提升视觉效果 */
  margin: 0; /* 移除默认margin */
}

/* 统一单元格标题样式 */
.van-cell__title {
  font-size: 20px; /* 统一标题大小 */
  font-weight: 600; /* 加粗重要信息 */
  -webkit-font-smoothing: antialiased; /* 优化字体渲染 */
}

.van-cell__value {
  font-size: 18px; /* 统一值的大小 */
  color: #333; /* 设置统一文本颜色 */
  -webkit-font-smoothing: antialiased; /* 优化字体渲染 */
}

/* 优化备注样式 */
.remarks {
  //width: 100%;
  font-size: 20px;
  color: #e64340; /* 使用品牌红色 */
  line-height: 1.5; /* 增加行高提升可读性 */
  padding: 10px 10px 10px 17px;
}

/* 分割标题样式统一 */
.section-title {
  font-size: 1.25rem;
  text-align: center;
  margin: 20px 0;
  padding: 10px;
  font-weight: bold;
}

.report-title {
  background-color: #1A7AF8;
  font-weight: bold;
  text-align: center;
  color: white;
  font-size: 1.25rem; /* 使用相对单位更好适配 */
  color: white;
  padding: 20px 0;
}

</style>
